import { TextInput } from './text.mjs';
import { registerCustomElement } from '../utils.mjs';

export class PathInput extends TextInput {}

registerCustomElement('imt-input-path', PathInput);
